import { useState, useEffect, useCallback } from 'react'

// Number of rows shown per page in the UI
export const PAGE_SIZE = 10
// How many records to request from the API in a single call (we display
// them across multiple pages via client-side pagination)
export const FETCH_LIMIT = 50

export function useBridgeList(fetcher, deps) {
  const [allData, setAllData] = useState([])
  const [count, setCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [error, setError] = useState(null)

  // Fetch everything we need in a single request, then paginate locally.
  const load = useCallback(
    async () => {
      setLoading(true)
      setError(null)
      try {
        const result = await fetcher(0, FETCH_LIMIT)
        setAllData(result.data || [])
        setCount(result.count || 0)
      } catch (err) {
        setError(err && err.message)
        setAllData([])
        setCount(0)
      } finally {
        setLoading(false)
      }
    },
    [fetcher]
  )

  useEffect(() => {
    load()
    setPage(1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  // Slice the fetched records for the active page (no refetch on page change)
  const start = (page - 1) * PAGE_SIZE
  const data = allData.slice(start, start + PAGE_SIZE)

  return { data, count, loading, page, error, setPage, reload: load }
}
